module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/calculator/calculator-item/shared/main/vehicle/vehicle.component.css
// module id = ./src/app/components/calculator/calculator-item/shared/main/vehicle/vehicle.component.css
// module chunks = main